import Quill from 'devextreme-quill';
import { LINE_HEIGHTS } from '../constants/line-heights';

export function registerCustomEditorFormats() {
  const Parchment = Quill.import("parchment");
  
  const LineHeightStyle = new Parchment.StyleAttributor(
    "lineheight",
    "line-height",
    {
      scope: Parchment.Scope.BLOCK,
      whitelist: LINE_HEIGHTS
    }
  );
  
  Quill.register({ "formats/lineHeight": LineHeightStyle }, true);
}